import { ReactNode, useContext, useEffect } from "react";
import { getAuthenticatedUserClient } from "../../utils/getAuthenticatedUser";
import { useRouter } from "next/router";
import { CookieContext } from "../../context/cookieContext";
import * as Sentry from "@sentry/nextjs";
import { useThemeOverride } from "../../theme";

type AuthenticatedUserThemeSetterProps = {
    children: ReactNode;
};

export const AuthenticatedUserThemeSetter = ({ children }: AuthenticatedUserThemeSetterProps) => {
    const router = useRouter();
    const token = useContext(CookieContext);
    const { setThemeOverride } = useThemeOverride();
    const { authenticatedUser } = getAuthenticatedUserClient(token, router, true);
    const { data } = authenticatedUser;

    useEffect(() => {
        if (!data) return;

        Sentry.setUser({
            username: `${data?.firstName} ${data?.lastName}`,
            id: data?.communicationId
        });

        setThemeOverride({
            customization: {
                profileFontSet: data.profileFontSet,
                backgroundColor: data.backgroundColor || "#FFFFFF",
                accentcolour: data.accentcolour || "#2E77FF",
                profileCollectionLayout: data.profileCollectionLayout,
                defaultView: data.defaultView,
                profileStyle: data.profileStyle
            }
        });
    }, [authenticatedUser.dataUpdatedAt]);

    return <>{children}</>;
};
